export default __webpack_public_path__ + "static/media/s.988b21de.svg";